import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering, HR
 * @graph-business 案件 FB のレイアウト。権限は子ルート側で見る（一覧は評価者向けに VIEW_ENGINEER_EVALUATION、詳細は API が本人・範囲内の評価者にだけ返す）
 * @graph-connects none
 */
export const Route = createFileRoute('/project-feedbacks')({
  component: ProjectFeedbacksLayout,
});

/** @graph-connects none */
function ProjectFeedbacksLayout() {
  return <Outlet />;
}
